export default {
  CREATE_TEAM: 'error when creating the team',
  GET_PAGE_DATA: 'error on getting frp data',
  GET_LOCK_DATA: 'error on getting lock data',
  UPDATE_FRP_DATA: 'error on updating frp data',
  NO_TEAM_DATA: 'no team data',
  CHECK_SHORT_NAME: 'error on checking team name',
  UPDATE_TEAM_SETTINGS: 'error on updating team settings',
  UPDATE_GIFT_AID_PREFERENCES: 'error on updating gift aid preferences',
  EVENT_SEARCH: 'error event search',
  UPDATE_TEAM_NAME: 'error on updating team name',
  GET_EVENT_DETAILS: "error getting event's details",
  GET_FUNDRAISING_PAGES: 'error getting fundraising pages',
  LINK_FUNDRAISING_PAGE: 'error linking fundraising page',
  GET_MEMBERS_LIST: 'error getting members list',
  CREATE_FUNDRAISING_PAGE: 'error creating fundraising page',
  GET_FRP_DATA: 'error on getting FRP data',
  UPDATE_SHORT_NAME: 'error on updating short name',
  UPDATE_FUNDRAISING_DATA: 'error on updating fundraising data',
  ACTIVATE_PAGE: 'error on activating page',
  CHECK_FRP_SHORT_NAME: 'error on checking frp name',
  UPDATE_MEMBERSHIP_POLICY: 'error on updating membership policy',
  UNLINK_MEMBER: 'error on unlinking member',
  GET_FRP_GUID: 'error on getting FRP guid',
  DELETE_TEAM: 'error on deleting team',
  FETCH_GDPR_CONSENTS: 'error on fetching gdpr consents',
  UPDATE_GDPR_CONSENTS: 'error on updating gdpr consents',
  UPDATE_TEAM_MEMBERS_TARGET: 'error on updating team members target',
  GET_MEMBERSHIP_DEFAULTS: 'error on getting membership default',
  UPDATE_STORY: 'error on updating story',
  GET_CHARITY_DATA: 'error getting charity data',
  UPDATE_LOCK_ERROR: 'error updating locks',
};
